import images from '../../config/local/images';
import LinkButton from '../../shared/LinkButton';
import React from 'react';

/**
 * @param {{
 * 	buttonText: string,
 * 	messages: React.ReactNode[],
 * 	title: string,
 * 	to: string
 * }} props
 * @returns {JSX.Element}
 */
export default function UpgradeOverlay(props) {
	return (
		<section className="my-5 message message-themed-light">
			<header className="header">
				<h2 className="title large">{props.title}</h2>
			</header>
			<main className="container-sm">
				<ul className="list-group">
					{props.messages.map((message) => (
						<li key={String(message)}>{message}</li>
					))}
				</ul>
			</main>
			<footer className="footer">
				<LinkButton
					className="button button-icon"
					icon={images.icons.subscription}
					iconClass="icon"
					to={props.to}
				>
					{props.buttonText}
				</LinkButton>
			</footer>
		</section>
	);
}
